/**
 * Created by DynamicDog on 2016-12-13.
 * Contains all components used in the etikett editing/creation panel.
 */

import { NgModule }      from '@angular/core';

import {EtikettService} from '../services/etikett.service';
import {TranslateService} from '../services/translate.service';
import {SharedModule} from "../shared.module";
import {UploadViewComponent} from "./upload.view";
import {ReglerPanelComponent} from "./reglerpanel.component";
import {PriserPanelComponent} from "./priserpanel.component";
import {BidragPanelComponent} from "./bidragpanel.component";
import {NetworkService} from "../services/network.service";

@NgModule({
    imports: [SharedModule],
    declarations: [
        UploadViewComponent,
        ReglerPanelComponent,
        PriserPanelComponent,
        BidragPanelComponent,
        ],

    providers: [EtikettService, TranslateService,NetworkService],
    exports: [UploadViewComponent]
})
export class UploadModule { }




// WEBPACK FOOTER //
// ./app/upload/upload.module.ts